import React, { useMemo } from 'react';
import { EventResultCardStyles as S } from './EventResultCard.styles';
import { SearchResultCardStyles as CardStyles } from '../SearchResultCard.styles';
import { DateTime } from 'luxon';
import ChevronRight from '@img/icons/chevron_right.svg';
import { getSvgFromSystem, SystemIcon } from '@helpers/systemIcons';
import { EventCardStyles } from '../../EventCard/EventCard.styles';
const EventResultCard = ({ tag, date, title, summary, cta, href, logo, location, }) => {
    const formattedDate = useMemo(() => {
        if (date) {
            return DateTime.fromISO(date).toFormat('dd MMM yy');
        }
        return undefined;
    }, [date]);
    return (React.createElement(CardStyles.Container, { href: href, target: "_blank" },
        React.createElement(S.TopBar, null,
            logo && (React.createElement(S.Logo, null,
                React.createElement("img", { src: logo }))),
            tag && React.createElement(CardStyles.ThemedPill, { text: tag.text || '', colour: tag.colour })),
        formattedDate && React.createElement(S.Date, null, formattedDate),
        React.createElement(CardStyles.Title, null, title),
        React.createElement(CardStyles.Content, null, summary),
        location && (React.createElement(EventCardStyles.LocationWrapper, null,
            getSvgFromSystem(SystemIcon.Location),
            React.createElement("span", null, location))),
        React.createElement(CardStyles.FakeCta, null,
            cta,
            " ",
            React.createElement(ChevronRight, null))));
};
export default EventResultCard;
